import React, { ReactNode, Children } from 'react';

export interface HeaderNavPrimaryProps {
  children: ReactNode;
}

const HeaderMegaCol = ({ children }: HeaderNavPrimaryProps): JSX.Element => {
  return (
    <div className="usa-col">
      <ul className="usa-nav__submenu-list">
        {children && Children.map(children, (child) => <li className="usa-nav__submenu-item">{child}</li>)}
      </ul>
    </div>
  );
};

export default HeaderMegaCol;
